// React.
import { useContext, useEffect, useState } from 'react';

// Types.
import InstanceTarget from '../../../types/instance/InstanceTarget';
import { TempDbSpaceTime, TempDbUsageSession } from '../../../types/instance/TempDb';

// Components.
import TempDbSpaceChart from '../../../component/instance/chart/TempDbSpaceChart';
import TempDbUsageTable from '../../../component/instance/table/TempDbUsageTable';

// Helper.
import { fetchResults } from '../../../helpers/utils';
import TempDbApi from '../../../api/instance/TempDbApi';
import FilterOption from "../../../types/instance/FilterOption";
import { showError } from '../../../utils/showAlert';

import { TimeRangeContext } from "../../../context/TimeRangeContext";
import { buildApiQuery } from "../../../helpers/timeRangeUtils";
import TabDisabledBanner from '../../../component/instance/TabDisabledBanner';

export default function TempDb(props: {
    instance: InstanceTarget,
    instanceTypes: any[],
    filterOptions: FilterOption[],
    setFilterOptions: Function,
}) {
    const { instance, instanceTypes } = props;
    const timeRangeContext = useContext(TimeRangeContext);

    const [tempDbSpace, setTempDbSpace] = useState<TempDbSpaceTime[]>([]);
    const [tempDbUsage, setTempDbUsage] = useState<TempDbUsageSession[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        async function load() {
            try {
                setLoading(true);
                const results: any[][] = await fetchResults(
                    [
                        TempDbApi.fetchSpaceTime(buildApiQuery(timeRangeContext.timeRange), instance.id),
                        TempDbApi.fetchUsageSession(buildApiQuery(timeRangeContext.timeRange), instance.id)
                    ]);

                if (active) {
                    setTempDbSpace(results[0]);
                    setTempDbUsage(results[1]);
                    setLoading(false);
                }
            } catch (x: any) {
                console.log(x.message);
                const errorMessage = x.message || x.toString();
                setError(errorMessage);
                showError('Failed to load TempDB data', errorMessage);
                setTempDbSpace([]);
                setTempDbUsage([]);
                setLoading(false);
            }
        }

        let active: boolean = true;
        load();
        return () => {
            // Clean up afterwards to avoid race conditions.
            active = false;
        }
    }, [instance.id, timeRangeContext.timeRange.from.valueOf(), timeRangeContext.timeRange.to.valueOf(), timeRangeContext.timeRange.interval]);

    return (<>
        <TabDisabledBanner instance={instance} instanceTypes={instanceTypes} collectFlag={!!instance.collecttempdb} defaultCollectKey="defaultcollecttempdb" featureName="TempDB" />
        <div className="row row-cols-1">
            <div id="space" className="tab-pane fade show active" role="tabpanel" aria-labelledby="space-tab">
                <TempDbSpaceChart error={error} loading={loading}
                                 
                                  data={tempDbSpace}/>
            </div>
            <div id="space" className="tab-pane fade show active" role="tabpanel" aria-labelledby="space-tab">
                <TempDbUsageTable error={error} loading={loading}
                                  setFilterOptions={props.setFilterOptions}
                                  data={tempDbUsage} instance={instance}/>
            </div>
        </div>
    </>)
}
